export const documentPaths = (value) => {
  try {
    const docs = JSON.parse(value || "{}");
    const paths = [
      ...(docs.idCardDocs || []),
      ...(docs.licenseDocs || []),
      ...(docs.vehicleDocs || []),
      docs.idCardFront,
      docs.idCardBack,
      docs.licenseFront,
      docs.licenseBack,
      docs.vehicleReport,
      docs.extraDocument,
      ...(docs.adminDocs || [])
    ];

    return paths.filter(Boolean);
  } catch {
    return [];
  }
};
